import {
  SET_ON_TYPING,
  SET_IS_CHAT_ENABLED,
  SET_MESSAGE_LIST,
  SET_IS_AGENT_CONNECTED,
  SET_SOUND_OFF,
  SET_MESSAGE_TO_SEND,
  SET_DELIVERED_MESSAGE_ID,
  SET_READ_MESSAGE_ID,
  SET_IS_CUSTOMER_MESSAGE_IN_VIEW,
} from "../actions/types.js";

const initialState = {
  onTyping: false,
  isChatEnabled: {
    restartFlag: false,
    isConnectParticipantTokenInvalid: false,
    isNetworkError: false,
  },
  webSocket: null,
  messageList: [],
  isAgentConnected: false,
  soundOff: false,
  deliveredMessageId: "",
  readMessageId: "",
  isCustomerMessageInView: true,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ON_TYPING:
      return { ...state, onTyping: action.payload };

    case SET_IS_CHAT_ENABLED:
      var isChatEnabled = Object.assign(
        state.isChatEnabled,
        action.payload.isChatEnabled
      );
      return {
        ...state,
        isChatEnabled: isChatEnabled,
      };

    case SET_MESSAGE_LIST:
      return {
        ...state,
        messageList: action.payload,
      };

    case SET_IS_AGENT_CONNECTED:
      return {
        ...state,
        isAgentConnected: action.payload,
      };

    case SET_SOUND_OFF:
      return {
        ...state,
        soundOff: action.payload,
      };

    case SET_MESSAGE_TO_SEND:
      return { ...state, messageToSend: action.payload };

    case SET_DELIVERED_MESSAGE_ID:
      return { ...state, deliveredMessageId: action.payload };

    case SET_READ_MESSAGE_ID:
      return { ...state, readMessageId: action.payload };

    case SET_IS_CUSTOMER_MESSAGE_IN_VIEW:
      return { ...state, isCustomerMessageInView: action.payload };

    default:
      return state;
  }
}
